import { createActionConst } from '../../../utils/action.utils';

const CHECKLISTITEM_NAMESPACE = 'CHECKLISTITEM';

export const STORE_CHECKLISTITEM = createActionConst(CHECKLISTITEM_NAMESPACE, 'STORE_CHECKLISTITEM');
export const CLEAR_CHECKLISTITEM = createActionConst(CHECKLISTITEM_NAMESPACE, 'CLEAR_CHECKLISTITEM');
